"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const map_data_service_1 = require("../../commons/map-data.service");
const _4d_mapper_1 = require("4d-mapper");
const router_1 = require("@angular/router");
const map_event_service_1 = require("../../commons/map-event.service");
const operators_1 = require("rxjs/operators");
class DetailsComponent {
    constructor(route, router, mapData, mapEvents) {
        this.route = route;
        this.router = router;
        this.mapData = mapData;
        this.mapEvents = mapEvents;
    }
    ngOnInit() {
        this.mapData.onSceneReady().subscribe(s => {
            this.route.params.subscribe(params => {
                this.layer = null;
                this.annot = null;
                var layerId = parseInt(params.layerId);
                var obs;
                if (params.objType == 'annot')
                    obs = this.mapData.annotations.events.pipe(operators_1.filter(a => a.item.id == layerId && a.event == 'ADD'), operators_1.take(1), operators_1.tap(a => this.annot = a.item));
                else if (params.objType == 'job')
                    obs = this.mapData.scenePhotos.events.pipe(operators_1.filter(a => a.item.id == layerId && a.event == 'ADD'), operators_1.take(1), operators_1.tap(a => this.photo = a.item));
                else if (params.objType == 'photo')
                    obs = this.mapData.scenePhotos.events.pipe(operators_1.filter(a => a.item.id == layerId && a.event == 'ADD'), operators_1.take(1), operators_1.tap(a => this.photo = a.item));
                else
                    obs = this.mapData.sceneLayers.events.pipe(operators_1.filter(a => a.item.id == layerId && a.event == 'ADD'), operators_1.take(1), operators_1.tap(a => {
                        this.layer = a.item;
                        this.opacity = this.mapData.scene.value.getAlpha(this.layer);
                    }));
                // clear the cursor
                this.mapEvents.cursor.value = null;
                this.mapEvents.setClickListener(this);
                obs.subscribe(_ => {
                    // dont move camera unless asked
                    if (params.jump == 'true')
                        this.mapEvents.flyCameraTo(this.layer || this.photo || this.annot);
                });
            });
        });
    }
    ngOnDestroy() {
        this.mapEvents.clearClickListener(this);
    }
    changeAlpha() {
        this.mapData.scene.value.setAlpha(this.layer, this.opacity);
        this.mapData.scene.value.saveObservable().subscribe();
        this.mapData.displayedLayers.set(this.layer);
    }
    onMapClicked(position, feature) {
        console.log('DetailsComponent', position, feature);
        // return false means still do super event
        return false;
    }
    delete() {
        if (confirm('Sure?')) {
            if (this.annot) {
                this.annot.destroyObservable().subscribe(_ => this.mapData.annotations.remove(this.annot));
            }
            if (this.layer) {
                this.mapData.scene.value.children.removeObservable(this.layer).subscribe(_ => this.mapData.sceneLayers.remove(this.layer));
            }
            if (this.photo) {
                this.mapData.scene.value.photos.removeObservable(this.layer).subscribe(_ => this.mapData.scenePhotos.remove(this.photo));
            }
        }
    }
}
exports.DetailsComponent = DetailsComponent;
